var _circle, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.429,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.143
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__clip0_1630_22545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.688 24.368a18.81 18.81 0 0 0-.276-3.25H24.32v6.16h8.643a7.406 7.406 0 0 1-3.199 4.863v3.997h5.156c3.028-2.786 4.768-6.902 4.768-11.77Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.321 40c4.316 0 7.955-1.416 10.606-3.862l-5.156-3.998c-1.434.976-3.286 1.529-5.444 1.529-4.174 0-7.713-2.816-8.983-6.603h-5.32v4.122A16.002 16.002 0 0 0 24.32 40Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.337 27.068a9.584 9.584 0 0 1 0-6.126V16.82h-5.315a16.014 16.014 0 0 0 0 14.369l5.315-4.121Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.321 14.333a8.695 8.695 0 0 1 6.138 2.399l4.568-4.568A15.378 15.378 0 0 0 24.321 8c-6.05 0-11.581 3.41-14.298 8.819l5.315 4.121c1.264-3.792 4.81-6.608 8.983-6.608Z",
    fill: "#EA4335"
  }))));
};

export default SvgGoogle;